import { type Actions, ActionType } from './dashboards.actions';
import { dashboardAdapter, initialState, type State } from './dashboards.state';

export function dashboardsReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.FETCH_DASHBOARDS: {
            return {
                ...state,
                isPending: true
            };
        }

        case ActionType.FETCH_DASHBOARDS_SUCCEDED: {
            return dashboardAdapter.setAll(action.payload.dashboards, {
                ...state,
                isLoaded: true,
                isPending: false
            });
        }

        case ActionType.FETCH_DASHBOARDS_FAILED: {
            return {
                ...state,
                isLoaded: false,
                isPending: false
            };
        }

        case ActionType.RESET: {
            return { ...initialState };
        }

        case ActionType.UPDATE_DASHBOARD: {
            return dashboardAdapter.updateOne(
                {
                    id: action.payload.dashboardId,
                    changes: action.payload.dashboard
                },
                state
            );
        }

        case ActionType.DELETE_DASHBOARD: {
            return dashboardAdapter.removeOne(action.payload.dashboardId, state);
        }

        default:
            return state;
    }
}
